import { select, Store } from '@ngrx/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { IAppState } from 'src/app/store/state/app.state';
import { IdentityUser } from 'src/app/models/auth';
import { AssumeUser } from 'src/app/store/auth/actions/auth.actions';
import { MatDialog } from '@angular/material/dialog';
import { TwoFactorAuthenticationComponent } from '../two-factor-authentication/two-factor-authentication.component';
import { getSignInState } from 'src/app/store/auth/selectors/auth.selectors';
import { ISignInState } from 'src/app/store/state/auth.signin.state';
import { AuthFacade } from 'src/app/store/auth/facade/auth.facade';
import { AppConfig } from 'src/app/app.config';

@UntilDestroy()
@Component({
    selector: 'app-select-account',
    templateUrl: './select-account.component.html',
    styleUrls: ['./select-account.component.scss']
})
export class SelectAccountComponent implements OnInit {
    public users: IdentityUser[];
    public showSpinner = false;
    public authFailText = '';
    public contactUsLink = '';
    private assumingUserId: number;

    constructor(
        private store: Store<IAppState>,
        private dialog: MatDialog,
        private authFacade: AuthFacade,
        private appConfig: AppConfig
    ) { }

    ngOnInit() {
        this.contactUsLink = this.appConfig.getLinks().contactUs;

        this.store.pipe(
            untilDestroyed(this),
            select(getSignInState)
        )
        .subscribe((state: ISignInState) => {
            this.showSpinner = state.loading;
            // Sort managers alphabetically
            this.users = [...state.identityUsers].sort((x, y) => x.managerName.localeCompare(y.managerName));

            if (state.requireTFA && !state.loading) {
                this.dialog.open(TwoFactorAuthenticationComponent)
                    .afterClosed().subscribe(tfaCode => {
                        if (tfaCode) {
                            this.store.dispatch(new AssumeUser(this.assumingUserId, tfaCode));
                        }
                    });
            }
        });

        this.authFacade.getAuthFailText()
            .pipe(untilDestroyed(this))
            .subscribe((failText: string) => {
                this.authFailText = failText;
            });
    }

    selectUser(userId: number) {
        this.assumingUserId = userId;
        this.showSpinner = true;
        this.store.dispatch(new AssumeUser(userId));
    }

    onSignOut() {
        this.authFacade.logout();
    }
}
